import {PersonalizationAction} from '@spartacus/tracking/personalization/core';

export interface ProfileTagPushEvent {
  name: string;
  data?: {
    segments?: string[];
    actions?: PersonalizationAction[];
    [x: string]: any;
  };
}

export class NavigatedPushEvent implements ProfileTagPushEvent {
  name = 'Navigated';
  data: any;

  constructor(data?) {
    this.data = data;
  }
}

export class KeywordSearchPushEvent implements ProfileTagPushEvent {
  name = 'KeywordSearch';
  data: any;

  constructor(data: {searchTerm: string; numResults: number}) {
    this.data = data;
  }
}

export class ProductViewPushEvent implements ProfileTagPushEvent {
  name = 'ProductDetailsPageViewed';
  data: any;

  constructor(data: {
    productSku: string;
    productName: string;
    productPrice: number;
    productCategory: string;
    productCategoryName: string;
    categories: Array<string>;
  }) {
    this.data = data;
  }
}

export class CategoryViewPushEvent implements ProfileTagPushEvent {
  name = 'CategoryPageViewed';
  data: any;

  constructor(data: {productCategory: string; productCategoryName: string}) {
    this.data = data;
  }
}

export class HomePageViewPushEvent implements ProfileTagPushEvent {
  name = 'HomePageViewed';
  data: any;

  constructor(data?: any) {
    this.data = data;
  }
}

export class OrderConfirmationPushEvent implements ProfileTagPushEvent {
  name = 'OrderConfirmationPageViewed';
  data: any;

  constructor(data?: any) {
    this.data = data;
  }
}

export class CartViewPushEvent implements ProfileTagPushEvent {
  name = 'CartPageViewed';
  data: any;

  constructor(data?: any) {
    this.data = data;
  }
}

export class AddedToCartPushEvent implements ProfileTagPushEvent {
  name = 'AddedToCart';
  data: any;

  constructor(data: {
    productQty: number;
    productSku: string;
    productName: string;
    cartId: string;
    cartCode: string;
    categories: Array<string>;
    productCategoryName: string;
    productCategory: string;
    productPrice: number;
  }) {
    this.data = data;
  }
}

export class RemovedFromCartPushEvent implements ProfileTagPushEvent {
  name = 'RemovedFromCart';
  data: any;

  constructor(data: {
    productSku: string;
    productName: string;
    productCategory: string;
    cartId: string;
    cartCode: string;
    productCategoryName: string;
    categories: Array<string>;
  }) {
    this.data = data;
  }
}

export class ModifiedCartPushEvent implements ProfileTagPushEvent {
  name = 'ModifiedCart';
  data: any;

  constructor(data: {
    productQty: number;
    productSku: string;
    productName: string;
    cartId: string;
    cartCode: string;
    categories: Array<string>;
    productCategoryName: string;
    productCategory: string;
  }) {
    this.data = data;
  }
}
